import { render, staticRenderFns } from "./TimelinessBadge.vue?vue&type=template&id=33e95d2e&"
import script from "./TimelinessBadge.vue?vue&type=script&lang=ts&"
export * from "./TimelinessBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports